import Vue from "vue";
import Vuex from "vuex";
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {StorageHelper} from "@/comunes/helpers/StorageHelper";
import {AppConfig} from "@/comunes/helpers/AppConfig";
import i18n from "../i18n";

Vue.use(Vuex);

export const ACTUALIZAR_USUARIO = 'ACTUALIZAR_USUARIO';
export const INCR_PREGS_USUARIO = 'INCREMENTAR_PREGUNTAS_USUARIO';
export const REST_PREGS_USUARIO = 'RESTAURAR_PREGUNTAS_USUARIO';
export const MOSTRAR_SNACKBAR = 'MOSTRAR_SNACKBAR';
export const OCULTAR_SNACKBAR = 'OCULTAR_SNACKBAR';
export const ASIG_GUARDANDO_PROYECTO = 'ASIG_GUARDANDO_PROYECTO';
export const LIMP_GUARDANDO_PROYECTO = 'LIMP_GUARDANDO_PROYECTO';
export const MOSTRAR_DIALOGO_CONFIRMACION = 'MOSTRAR_DIALOGO_CONFIRMACION';
export const MOSTRAR_DIALOGO_ACEPTACION = 'MOSTRAR_DIALOGO_ACEPTACION';

const STORAGE_GUARDANDO_PROYECTO_ID = "storage_guardando_proyecto_id";

export default new Vuex.Store({
    state: {
        usuario: null,
        preguntasDeUsuario: 0,
        snackBar: {
            mostrar: false,
            texto: "",
            color: "",
            timeout: -1
        },
        guardandoProyectoId: null,
        confirmarDialogo: {
            mostrar: false,
            color: "",
            titulo: "",
            texto: "",
            resolver: null,
            rechazar: null
        },
    },
    mutations: {
        [ACTUALIZAR_USUARIO](state, usuario) {
            state.usuario = usuario;
        },
        [INCR_PREGS_USUARIO](state) {
            state.preguntasDeUsuario += 1;
        },
        [REST_PREGS_USUARIO](state) {
            state.preguntasDeUsuario = 0;
        },
        [MOSTRAR_SNACKBAR](state, data) {
            if (state.snackBar.mostrar) {
                this.commit(OCULTAR_SNACKBAR);
                setTimeout(() => {
                    this.commit(MOSTRAR_SNACKBAR, data);
                }, 150);
                return;
            }

            state.snackBar.texto = data.texto;
            state.snackBar.color = data.color;
            state.snackBar.mostrar = true;
            if (!data || typeof data.timeout === "undefined")
                state.snackBar.timeout = data.color === "error" ? -1 : 5000;
            else
                state.snackBar.timeout = data.timeout;
        },
        [OCULTAR_SNACKBAR](state) {
            state.snackBar.texto = "";
            state.snackBar.color = "";
            state.snackBar.mostrar = false;
            state.snackBar.timeout = -1;
        },
        [ASIG_GUARDANDO_PROYECTO](state, id) {
            StorageHelper.put(STORAGE_GUARDANDO_PROYECTO_ID, id);
            state.guardandoProyectoId = id;
        },
        [LIMP_GUARDANDO_PROYECTO](state) {
            StorageHelper.delete(STORAGE_GUARDANDO_PROYECTO_ID);
            state.guardandoProyectoId = null;
        }
    },
    getters: {
        snackBar: state => {
            return state.snackBar
        },
        usuario: state => {
            return state.usuario
        },
        hayUsuario: state => {
            return state.usuario != null;
        },
        usuarioEsAdmin: state => {
            if (state.usuario == null) return false;
            return state.usuario.permisos.includes("ROLE_ADMIN");
        },
        guardandoProyectoId: state => {
            if (state.guardandoProyectoId != null) return state.guardandoProyectoId;

            let pId = StorageHelper.get(STORAGE_GUARDANDO_PROYECTO_ID);
            if (pId == null) return null;

            state.commit(ASIG_GUARDANDO_PROYECTO, pId);
            return pId;
        },
        confirmarDialogo: state => {
            return state.confirmarDialogo
        }
    },
    actions: {
        cambiaUsuarioLocalStorage({dispatch}) {
            return dispatch('cargarUsuario');
        },
        cargarUsuario({commit, state}) {
            return new Promise((resolve) => {
                let token = StorageHelper.get(AppConfig.TOKEN_CLAVE);
                let usuarioAnterior = state.usuario;

                if (token == null) {
                    commit(ACTUALIZAR_USUARIO, null);
                    commit(REST_PREGS_USUARIO);

                    if (usuarioAnterior != null)
                        commit(MOSTRAR_SNACKBAR, {
                            texto: i18n.t("sesion_cerrada"),
                            color: "success"
                        });

                    resolve();
                    return;
                }

                commit(INCR_PREGS_USUARIO);

                if (state.usuario != null && state.preguntasDeUsuario < 5) {
                    resolve();
                } else {
                    HttpHelper.get("auth/info-usuario")
                        .then((usuario) => {
                            commit(ACTUALIZAR_USUARIO, usuario);
                            StorageHelper.put(AppConfig.TOKEN_CLAVE, usuario.token);
                            if (usuarioAnterior == null && !usuario.isPoliticaAceptada &&
                                !usuario.permisos.includes("ROLE_ADMIN")) {
                                commit(MOSTRAR_SNACKBAR, {
                                    texto: i18n.t("error_politica_privacidad"),
                                    color: "error"
                                });
                            }
                            resolve();
                        })
                        .catch(() => {
                            StorageHelper.delete(AppConfig.TOKEN_CLAVE);
                            commit(ACTUALIZAR_USUARIO, null);
                            resolve();
                        })
                        .finally(() => {
                            commit(REST_PREGS_USUARIO);
                        });
                }
            });
        },
        [MOSTRAR_DIALOGO_CONFIRMACION]({state}, data) {
            state.confirmarDialogo.titulo = data.titulo;
            state.confirmarDialogo.texto = data.texto;
            state.confirmarDialogo.color = data.color ? data.color : "primary";
            state.confirmarDialogo.mostrar = true;
            let esAceptacion = data.aceptacion;

            let cerrarDialogo = () => {
                state.confirmarDialogo.titulo = "";
                state.confirmarDialogo.texto = "";
                state.confirmarDialogo.mostrar = false;
            }
            return new Promise((resolve, reject) => {
                state.confirmarDialogo.resolver = () => {
                    cerrarDialogo();
                    resolve(true);
                };

                state.confirmarDialogo.rechazar = esAceptacion
                    ? null
                    : () => {
                        cerrarDialogo();
                        reject(false)
                    };
            });
        },
        [MOSTRAR_DIALOGO_ACEPTACION]({dispatch}, data) {
            data.aceptacion = true;

            return dispatch(MOSTRAR_DIALOGO_CONFIRMACION, data);
        },
    }
});